import * as React from "react";
import { Header } from "./Header/Header";
import { Footer } from "./Footer/Footer";
import { Outlet } from "react-router-dom";
import LoadingWrapper from "../../Components/LoadingWrapper";

export const MainLayout = ({ children }) => {
  return (
    <>
      <Header />
      <LoadingWrapper>
        <main className="main">{children || <Outlet />}</main>
      </LoadingWrapper>
      <Footer />
    </>
  );
};
